<fgb-page-header [pageTitle]="'payment.page.title'" [backButtonLink]="'/'"></fgb-page-header>
<fgb-route-nav>
  <a
    class="nav-item leaderboard-nav-item"
    [routerLink]="['/payment']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    {{ 'navbar.payment' | translate : { fgbdefault: 'Play' } }}
  </a>
  <a
    class="nav-item leaderboard-nav-item"
    [routerLink]="['/payment/transaction-history']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    {{ 'navbar.ecash.history' | translate : { fgbdefault: 'Leaderboard' } }}
  </a>
</fgb-route-nav>
<router-outlet></router-outlet>
